/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/store';
Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: '/patient',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'static',
                    component: () => import('./views/patient/Static.vue'),
                    meta: { auth: true, tab_sum: 1, title: '통계' },
                },
                {
                    path: 'list',
                    component: () => import('./views/patient/List.vue'),
                    meta: { auth: true, tab_sum: 1 , title: '환자관리' },
                },
                //  230315 TH 삭제예정
                //  기존의 코드가 최신이 아니라 탭 설정에 관한 사항을 DB와 맞춰 분리함
                // {
                //     path: 'scheduleCalendar/:uid',
                //     component: () => import('./views/patient/ScheduleCalendar.vue'),
                //     meta: { auth: true, tab_sum: 16384 },
                // },
                // {
                //     path: 'scheduleList/:uid',
                //     component: () => import('./views/patient/ScheduleList.vue'),
                //     meta: { auth: true, tab_sum: 1 },
                // },
            ],
        },
        {
            path: '/ward',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/ward/List.vue'),
                    meta: { auth: true, tab_sum: 2, title: '병동 스케쥴'  },
                },
            ],
        },
        {
            path: '/ward_status',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/ward_status/List.vue'),
                    meta: { auth: true, tab_sum: 4, title: '병동현황'  },
                },
            ],
        },
        {
            path: '/remote',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/remote/List.vue'),
                    meta: { auth: true, tab_sum: 64, title: '(구)입퇴원/외래'  },
                },
                {
                    path: 'list2',
                    component: () => import('./views/remote/List2.vue'),
                    meta: { auth: true, tab_sum: 4096, title: '입퇴원리스트'  },
                },
            ],
        },

        {
            path: '/management',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'ward',
                    component: () => import('./views/management/Ward.vue'),
                    meta: { auth: true, tab_sum: 256, title: '병동관리'  },
                },
                {
                    path: 'room/:medical_room_seq',
                    component: () => import('./views/management/Room.vue'),
                    meta: { auth: true, tab_sum: 256, title: '치료실관리'  },
                },
                {
                    path: 'treatmentRoom',
                    component: () => import('./views/management/TreatmentRoom.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '치료실관리' },
                },
                {
                    path: 'injectionRoom',
                    component: () => import('./views/management/InjectionRoom.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '외래치료실관리' },
                },
                {
                    path: 'treatmentRoomNew',
                    component: () => import('./views/management/TreatmentRoomNew.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '외래치료실관리' },
                },
                {
                    path: 'directorRoom',
                    component: () => import('./views/management/DirectorRoom.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '기타' },
                },
                {
                    path: 'admin',
                    component: () => import('./views/management/Admin.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '관리자관리' },
                },
                {
                    path: 'ip/:uid',
                    component: () => import('./views/management/IpList.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '아이피관리' },
                },
                {
                    path: 'kakaoHistory',
                    component: () => import('./views/management/KakaoHistory.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '알림톡 로그관리' },
                },
                {
                    path: 'logHistory',
                    component: () => import('./views/management/LogHistory.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '로그기록' },
                },
                {
                    path: 'noticelist',
                    component: () => import('./views/management/NoticeList.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '공지사항' },
                },
                {
                    path: 'hospital',
                    component: () => import('./views/management/Hospital.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '병원정보' },
                },
                {
                    path: 'oxygenPoint',
                    component: () => import('./views/management/oxygenPointHistory.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '포인트적립내역' },
                },
                {
                    path: 'holiday',
                    component: () => import('./views/management/holidayManage.vue'),
                    meta: { auth: true, tab_sum: 256 , title: '휴일관리' },
                },
            ],
        },
        {
            path: '/doctor',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/doctor/List.vue'),
                    meta: { auth: true, tab_sum: 8 , title: '원장님 스케쥴' },
                },
                {
                    path: 'patient/list',
                    component: () => import('./views/doctor/patient/List.vue'),
                    meta: { auth: true, tab_sum: 8 , title: '담당환자 관리' },
                },
            ],
        },
        {
            path: '/cs',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                // {
                //     path: 'list',
                //     component: () => import('./views/cs/List.vue'),
                //     meta: { auth: true, tab_sum: 1024 , title: '상담내역' },
                // },
                // {
                //     path: 'schedule',
                //     component: () => import('./views/cs/Schedule.vue'),
                //     meta: { auth: true, tab_sum: 1024 , title: '상담내역' },
                // },
                {
                    path: 'todo',
                    component: () => import('./views/cs/TodoOptimized.vue'),
                    meta: { auth: true, tab_sum: 1024 , title: '상담내역' },
                },
            ],
        },
        {
            path: '/vacation',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'schedule',
                    component: () => import('./views/vacation/Schedule.vue'),
                    meta: { auth: true, tab_sum: 131072, title: '연차 관리' },
                },
            ],
        },
        {
            path: '/cure',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/cure/List.vue'),
                    meta: { auth: true, tab_sum: 16 , title: '치료실 스케쥴' },
                },
            ],
        },
        {
            path: '/injection',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/injection/List.vue'),
                    meta: { auth: true, tab_sum: 32 , title: '외래치료실 스케쥴' },
                },
            ],
        },
        {
            path: '/',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: '',
                    component: () => import('@/views/Login.vue'),
                },
                {
                    path: '/pages/error-404',
                    component: () => import('@/views/pages/Error404.vue'),
                },
            ],
        },
        {
            path: '/message',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'schedule',
                    name: 'message-schedule',
                    component: () => import('@/views/message/Schedule.vue'),
                    meta: { auth: true, tab_sum: 128 , title: '외진스케쥴' },
                },
                {
                    path: 'walkschedule',
                    name: 'walk-schedule',
                    component: () => import('@/views/message/Walkschedule.vue'),
                    meta: { auth: true, tab_sum: 128 , title: '산책스케쥴' },
                },
                {
                    path: 'healingcenter',
                    name: 'healing-center',
                    component: () => import('@/views/message/Healingcenter.vue'),
                    meta: { auth: true, tab_sum: 128 , title: '힐링센터' },
                },
            ],
        },
        {
            path: '/meal',
            component: () => import('@/layouts/full-page/FullPage.vue'),
            children: [
                {
                    path: 'main',
                    name: 'meal-main',
                    component: () => import('@/views/meal/Main.vue'),
                    meta: {
                        breadcrumb: [{ title: '검색', url: '/meal/main' }],
                        pageTitle: '환자검색',
                        rule: 'editor',
                        tab_sum: 512,
                        title: '식사관리' 
                    },
                },
                {
                    path: 'view',
                    name: 'meal-view',
                    component: () => import('@/views/meal/View.vue'),
                    meta: {
                        breadcrumb: [
                            { title: '검색', url: '/meal/main' },
                            { title: '식사관리', active: true },
                        ],
                        pageTitle: '식사관리',
                        rule: 'editor',
                        tab_sum: 512,
                        title: '식사관리' 
                    },
                },
                {
                    path: 'detailview/:uid',
                    name: 'meal-detailview',
                    component: () => import('@/views/meal/DetailView.vue'),
                    meta: {
                        breadcrumb: [
                            { title: '검색', url: '/meal/main' },
                            { title: '식사관리', active: true },
                        ],
                        pageTitle: '식사관리',
                        rule: 'editor',
                        title: '식사관리' 
                    },
                },
            ],
        },
        {
            path: '/nutrition',
            component: () => import('@/layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    name: 'nutrition-list',
                    component: () => import('@/views/nutrition/List.vue'),
                    meta: { auth: true, tab_sum: 8192, title: '영양팀' },
                },
            ],
        },

        // 230315 TH 추가 DB에 맞춰 탭 목록을 분리함

        {
            path: '/patientSchedule',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'scheduleCalendar',
                    component: () => import('./views/patient/ScheduleCalendar.vue'),
                    props : false,
                    meta: { auth: true, tab_sum: 16384, title: '환자스케쥴'  },
                },
                {
                    path: 'scheduleCalendar/:uid',
                    name: 'scheduleCalendar',
                    component: () => import('./views/patient/ScheduleCalendar.vue'),
                    props : true,
                    meta: { auth: true, tab_sum: 16384, title: '환자스케쥴' },
                },
                {
                    path: 'scheduleList',
                    component: () => import('./views/patient/ScheduleList.vue'),
                    props : false,
                    meta: { auth: true, tab_sum: 16384, title: '환자스케쥴' },
                },
                {
                    path: 'scheduleList/:uid',
                    component: () => import('./views/patient/ScheduleList.vue'),
                    props : false,
                    meta: { auth: true, tab_sum: 16384, title: '환자스케쥴' },
                },
            ],
        },
        {
            path: '/treatment',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'list',
                    component: () => import('./views/treatment/List.vue'),
                    props : false,
                    meta: { auth: true, tab_sum: 32768, title: '치료실스케쥴' },
                },
            ],
        },
        {
            path: '/dashboard',
            component: () => import('./layouts/main/Main.vue'),
            children: [
                {
                    path: 'main',
                    component: () => import('./views/dashboard/dashboard.vue'),
                    props : false,
                    meta: { auth: true, tab_sum: 65536, title: '대시보드' },
                },
            ],
          },

    ],
});


router.afterEach((to, from) => {
    // Remove initial loading
    const title = to.meta.title === undefined ? '메디람한방병원' : to.meta.title;
    Vue.nextTick(() => {
        document.title = title;
    });
    const appLoading = document.getElementById('loading-bg');
    if (appLoading) {
        appLoading.style.display = 'none';
    }
});

router.beforeEach(async function(to, from, next) {
    // console.log(to.matched.some(record => record.meta.title));
    if (to.path != '/') {
        // console.log("store.getters.getTABSUM===>"+store.getters.getTABSUM);
        // console.log("to.meta.tab_sum===>"+to.meta.tab_sum);
        // console.log("to.meta.tab_sum===>"+to.meta.uid);
        
        if ((to.meta.tab_sum & store.getters.getTABSUM) == false) {
            alert('접속권한이 없습니다');
            history.back();
        }
        if (to.matched.some(record => record.meta.auth) == true) {
            if (store.getters.getTOKEN) {
                next();
            } else {
                location.href = '/';
            }
        } else {
            next();
        }
    } else {
        next();
    }

    // next();
});

export default router;
